<div class="container-fluid text-center py-4 h-100 d-flex align-items-center mt-5">
  <div class="container">
    <img alt="busqueda" src="../../../../assets/img/lupa.png" height="70">
    <h6 class="mb-0 text-center mt-4">
      No se encontró información con los filtos seleccionados
    </h6>
  </div>
</div>
